import { createSlice } from "@reduxjs/toolkit";

const workflowSlice = createSlice({
  name: "workflowSetter",
  initialState: {
    workflowName: "",
    workflowId: "",
    worflowTemplateId: "",
    workflowDescription: "",
    workflowRerunFlag: false,
    workflowLoading: true,
    backFromAllWorkflows: false,
  },
  reducers: {
    setWorkflowName: (state, action) => {
      state.workflowName = action.payload;
    },
    setWorkflowId: (state, action) => {
      state.workflowId = action.payload;
    },
    setWorkflowTemplateId: (state, action) => {
      state.worflowTemplateId = action.payload;
    },
    setWorkflowDescription: (state, action) => {
      state.workflowDescription = action.payload;
    },
    setBackFromAllWorkflows: (state, action) => {
      state.backFromAllWorkflows = action.payload;
    },
    setWorkflowRerunFlag: (state, action) => {
      state.workflowRerunFlag = action.payload;
    },
    setWorkflowLoading: (state, action) => {
      state.workflowLoading = action.payload;
    },
    resetWorkflowState: (state) => {
      state.workflowName = "";
      state.workflowId = "";
      state.worflowTemplateId = "";
      state.workflowDescription = "";
      state.backFromAllWorkflows = false;
      state.workflowRerunFlag = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setWorkflowName,
  setWorkflowId,
  setWorkflowTemplateId,
  setWorkflowDescription,
  setBackFromAllWorkflows,
  resetWorkflowState,
  setWorkflowRerunFlag,
  setWorkflowLoading,
} = workflowSlice.actions;

export default workflowSlice.reducer;
